import { Tag } from 'antd-mobile'
import { CheckCircleFill, CloseCircleFill } from 'antd-mobile-icons'
import { reviewType } from 'utils/constant'
import 'static/css/BpmApplyResult.css'

/** 审核状态之右上角的小状态 */
export function BpmApplyResult(props) {
  const { result, resultflag } = props
  const { SUCCESS, FAIL } = reviewType

  /** 颜色 */
  function resultColor(type) {
    switch (type) {
      case SUCCESS:
        return '#2CA150'
      case FAIL:
        return '#FF5858'
      default:
        return '#2773C5'
    }
  }

  /** 状态前小图标 */
  function resultIcon(type) {
    switch (type) {
      case SUCCESS:
        return <CheckCircleFill fontSize={14} />
      case FAIL:
        return <CloseCircleFill fontSize={14} />
      default:
        return null
    }
  }

  return (
    <Tag
      className={`applyResult ${resultflag === FAIL && 'applyFailing'}`}
      // resultflag=1(审核通过)|2(审核不通过)|0(审核中)
      color={resultColor(resultflag)}
      fill='outline'
    >
      {resultIcon(resultflag)}
      {result}
    </Tag>
  )
}